import moment from "moment/moment";

export default {
    data() {
        return {};
    },
    methods: {
        formatDate(date, format = 'DD-MM-YYYY') {
            if (date && format === 'H:mm') {
                date = date.replace(/.*\s/, '').replace(/:\d\d$/, '');
                return date;
            }

            if (!date || date.includes('-0001-11-30') || date.includes('0000-00-00')) {
                return '';
            }

            return moment(date).format(format);
        },
        getDropoffTime(booking, type) {
            if (booking[`force_dropoff_${type}_time`]) {
                return booking[`force_dropoff_${type}_time`];
            }

            let date = (booking.dropoff_trip && booking.dropoff_trip[`delivered_${type}`]) ?
                booking.dropoff_trip[`delivered_${type}`] :
                booking[`dropoff_${type}`];

            return this.formatDate(date, 'H:mm');
        },
        formatDateTime(dateTime) {
            return dateTime ? moment(dateTime).format('DD-MM-yyyy HH:mm') : '';
        },
        getPickupTime(booking, type, configTime) {
            let time;

            if (booking.pickup_trip && booking.pickup_trip[`delivered_${type}`]) {
                time = this.formatDate(booking.pickup_trip[`delivered_${type}`], 'H:mm');

            } else if (booking[`pickup_${type}`]) {
                time = this.formatDate(booking[`pickup_${type}`], 'H:mm');

            } else {
                time = configTime;
            }
            return time;
        }
    },
};
